import config from '../../envConfig';

export enum StoreBranches {
  Permissions = 'permissions',
  Global = 'global',
  Exercises = 'exercises',
}

export enum REDUX_CACHE {
  LIST = 'LIST',
  ABORT_INVALIDATION = 'ABORT',
}

export const HTTP_METHOD = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  PATCH: 'PATCH',
  DELETE: 'DELETE',
};

const baseURL = config.apiBaseUrl;

export const constants = {
  baseURL,
};

export enum EXERCISE_PAGES {
  ALL = 'all',
  SELECTED = 'selected',
  PUBLIC = 'public',

  APPROVE_REQUESTED = 'approveRequested',
}

export enum EXERCISE_CONFIG {
  EXERCISE_OPTIONS = 'exerciseOptions',
  EXERCISE_CATEGORIES = 'exerciseCategories',
}

export enum TRANSLATIONS {
  TRANSLATIONS = 'translations',
  LANGUAGES = 'languages',
}

export enum LANGUAGES {
  ACTIVE = 'active',
  ALL = 'all',
}

export enum PROGRAMS {
  PROGRAMS = 'programs',
  PROGRAM_ITEMS = 'programItems',
  AVAILABLE = 'programsAvailable',
  EXERCISES = 'programItemExercises',
}

export enum TRAININGS {
  TRAININGS = 'trainings',
  TRAINING_ITEMS = 'trainingItems',
  CURRENT = 'current',
  AVAILABLE = 'programsAvailable',
}

export enum ACL {
  ACL_ITEM = 'aclItem',
}

export enum CHATS {
  CHATS = 'chats',
  SELECTED_CHAT = 'selectedChat',
  UNREAD_MESSAGES = 'unreadMessages',
}

export enum COMMUNITIES {
  COMMUNITIES = 'communities',
  COMMUNITY_SUBSCRIBERS = 'communitySubscribers',
  SELECTED_COMMUNITY = 'selectedCommunity',
  COMMUNITY_REQUESTS = 'communityRequests',
  MY_COMMUNITIES = 'myCommunities',
}

export enum POSTS {
  POSTS = 'posts',
  NEWS = 'news',
}

export enum ROLES {
  ROLES = 'roles',
}

export enum SEARCH {
  SEARCH = 'search',
}

export enum USERS {
  USERS = 'users',
  ADMIN_USERS = 'adminUsers',
  ME = 'me',
  RESTRICTIONS = 'restrictions',
  PERMISSIONS = 'permissions',
  USER_COMMUNITIES = 'userCommunities',
  USER_SUBSCRIBERS = 'userSubscribers',
  USER_SUBSCRIPTION_REQUESTS = 'userSubscriptionRequests',
  USER_SUBSCRIBER_REQUESTS = 'userSubscriberRequests',
  REJECTED_USER_SUBSCRIBER_REQUESTS = 'rejectedUserSubscriberRequests',
  USER_SUBSCRIPTIONS = 'userSubscriptions',
  SELECTED_USER = 'selectedUser',
}

export enum SUBSCRIPTIONS {
  PLANS = 'plans',
  PLAN_PRICES = 'planPrices',
  RESTRICTIONS = 'restrictions',
}

export enum BUG_REPORTS {
  BUG_REPORT_TYPES = 'bugReportTypes',
  BUG_REPORT_TYPE = 'bugReportType',
  BUG_REPORT = 'bugReport',
  BUG_REPORT_HISTORY = 'bugReportHistory',
  BUG_REPORTS = 'bugReports',
}

export enum APP_CONFIG {
  APP_VARIABLE = 'appVariable',
  APP_VARIABLES = 'appVariables',
  APP_FEATURES = 'appFeatures',
  APP_FEATURE = 'appFeature',
  AI_PROMPT = 'aiPrompt',
  AI_PROMPTS = 'aiPrompts',
  EXERCISE_LOAD_FORMULAS = 'exerciseLoadFormulas',
  EXERCISE_LOAD_FORMULA = 'exerciseLoadFormula',
}

export enum TRAINING_ACTIVITY_TYPES {
  TRAINING_ACTIVITY_TYPES = 'trainingActivityTypes',
  TRAINING_ACTIVITY_TYPE = 'trainingActivityType',
}

export enum AGREEMENTS {
  DOCUMENT_VERSIONS = 'agreementDocumentVersions',
  DOCUMENT_ITEMS = 'agreementDocumentItems',
}

export enum SYNC {
  MUSCLES = 'syncMuscles',
  EXERCISES = 'syncExercises',
}

export enum SUPPORT_REQUESTS {
  SUPPORT_REQUEST = 'supportRequest',
  ACTIVE_SUPPORT_REQUESTS = 'activeSupportRequests',
  ARCHIVED_SUPPORT_REQUESTS = 'archivedSupportRequests',
}
